export default class RoomVO {
    GameCode?: string;
    GameType?: string;
    // 房间桌名（服务端 RoomVO.RoomName，如 AS2/RB...）
    RoomName?: string;
    HasUpdateStartTime?: boolean;
    IsInit?: boolean;
    /**
     * 数据包所在索引
     */
    NextIndex?: boolean;
    /**
     * 下一次运行的时间
     */
    NextRunTime?: string;
    /**
     * 锚点数量
     */
    GameInfoStatusPointCount?: number = 0;
    /**
     * 缓存数量
     */
    CacheGameInfoCount?: number = 0;
    OpenKillPig?: boolean;
    StartTime?: string;
    VirtualDealer?: string;
    VirtualMaps?: string[];
    /**
     * 解码后的Maps
     */
    VirtualMapsDecoding?: number[];
    /**
     * 局号
     */
    VirtualJuNumber?: string;
    /**
     * 子局号
     */
    VirtualChildJuNumber?: string;
    /**
     * 游戏状态
     */
    VirtualST: "waiting" | "betting" | "dealing" | "" = "";
    /**
     * 
     */
    WaitJumpNewGame?: boolean;

    /**
     * 视频相关数据
     */
    VideoDataDic?: {
        [videoName: string]: {
            VideoName: string,
            CurrentIndex: number,
            AllIndexCount: number
        }
    } = {};


    /**
     * 获取房间号
     */
    public get RoomNumber(): string {
        return `${this.GameType}-${this.GameCode}`;
    }

    public get label() {
        return this.RoomNumber;
    }

    public get value() {
        return this.RoomNumber;
    }

}